// @ts-nocheck
import { useInfiniteQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { WallPost, WallPostAuthor } from './useWallFeed';

interface UserPostsPage {
  posts: WallPost[];
  nextCursor: number | null;
}

const PAGE_SIZE = 20;

export function useUserPosts(profileId: string | undefined) {
  return useInfiniteQuery({
    queryKey: ['user-posts', profileId],
    queryFn: async ({ pageParam = 0 }) => {
      if (!profileId) throw new Error('No profile ID');

      const { data, error } = await supabase
        .from('wall_posts')
        .select(`
          id,
          content,
          media_urls,
          hashtags,
          created_at,
          updated_at,
          profile_id,
          comments_count,
          likes_count,
          reactions_count,
          share_count,
          post_type,
          is_pinned,
          is_boosted,
          profiles!wall_posts_profile_id_fkey (
            id,
            first_name,
            last_name,
            username,
            avatar_url
          )
        `)
        .eq('profile_id', profileId)
        .eq('is_hidden', false)
        .order('is_pinned', { ascending: false })
        .order('created_at', { ascending: false })
        .range(pageParam, pageParam + PAGE_SIZE - 1);

      if (error) throw error;

      const posts: WallPost[] = (data || []).map((post: any) => ({
        ...post,
        media_urls: post.media_urls as string[] | null,
        hashtags: post.hashtags as string[] | null,
        reactions_count: post.reactions_count as Record<string, number> | null,
        author: post.profiles as WallPostAuthor,
      }));

      return {
        posts,
        nextCursor: posts.length === PAGE_SIZE ? pageParam + PAGE_SIZE : null,
      } as UserPostsPage;
    },
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    initialPageParam: 0,
    enabled: !!profileId,
  });
}
